import { render } from "./Modal.vue?vue&type=template&id=811387c4&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=811387c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811387c4"]])

export default __exports__